const VehicleDetailsActions = {
    SET_VEHICLE_DATA: 'SET_VEHICLE_DATA',
    LOAD_VEHICLE_DATA_ACTION: 'LOAD_VEHICLE_DATA_ACTION',
};

export { VehicleDetailsActions };